module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/3@2x_02f17689af31acbf5c9db62fffc58e06.png";